// extracted by mini-css-extract-plugin
export default {"box":"VerificationBoxCustom_box__egWYw"};